<template>
    <div class="uik-search">
        <div class="uik-search__container">
            <uikon v-if="value === '' && !searchString" class="uik-search__icon">search_left</uikon>
            <button v-if="value !== '' || searchString" class="uik-search__icon" @click="clearSearch">
                <uikon>add</uikon>
            </button>
            <input
                :value="value || searchString"
                :autofocus="autofocus"
                :maxlength="maxlength"
                :placeholder="placeholderValue"
                class="uik-search__input"
                :class="{'uik-search__input--clear': clear}"
                @input="handleInput"
                @change="handleChange"
                @blur="$emit('blur', $event.target.value)"
                @focus="$emit('focus', $event.target.value)"
                @keydown.enter="$emit('keydown-enter', $event)"
                @keydown.esc="$emit('keydown-esc', $event)"
                @keyup.enter="$emit('keyup-enter', $event)"
                @keyup.esc="$emit('keyup-esc', $event)"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "UikSearch",
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        placeholder: {
            type: String,
            default: ""
        },
        value: { type: String, default: "" },
        autofocus: { type: Boolean, default: false },
        maxlength: { type: Number, default: undefined },
        clear: { type: Boolean, default: false },
        /**
         * The resource this table is showing data for
         */
        resource: { type: [Object, null], default: null },
        /**
         * The module namespace the filter will be saved under
         */
        filterModuleNamespace: { type: [String, null], default: null },
        /**
         * The key namespace the filter will be saved under
         */
        filterKey: { type: [String, null], default: null },
        /**
         * The columns we want to search in
         */
        searchColumns: { type: [Array, null], default: null }
    },
    data () {
        return {
            timer: null,
            inputTriggeredSearch: false
        }
    },
    computed: {
        placeholderValue () {
            if (this.placeholder === "") return this.$t("UIK.components.universal.search.search", "Search ...")
            return this.placeholder
        },
        searchString () {
            if (
                !this.resource ||
                !this.resource.filters[this.$route.name] ||
                !this.resource.filters[this.$route.name].search ||
                !this.resource.filters[this.$route.name].search.search
            ) return null
            let searchString = this.resource.filters[this.$route.name].search.search[1]
            return searchString === "" ? null : searchString
        }
    },
    methods: {
        clearSearch () {
            this.$emit("input", "")
            this.$emit("change", "")
            if (this.resource) {
                this.removeSearchFilter()
                this.resource.getList()
            }
        },
        handleInput (event) {
            let search = event.target.value
            this.$emit("input", search)
            if (this.timer) clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.triggerSearch(search)
                this.inputTriggeredSearch = true
            }, 500)
        },
        handleChange (event) {
            let search = event.target.value
            this.$emit("change", search)
            if (this.timer) clearTimeout(this.timer)
            if (!this.inputTriggeredSearch) this.triggerSearch(search)
            this.inputTriggeredSearch = false
        },
        triggerSearch (search) {
            if (!this.resource) return
            if (search === "") {
                this.removeSearchFilter()
                return this.resource.getList()
            }
            let filterParams = {
                module: this.filterModuleNamespace || this.$route.name,
                key: this.filterKey || "search",
                params: {
                    search: [this.searchColumns, search]
                }
            }
            this.resource.setFilter(filterParams)
            this.resource.getList()
        },
        removeSearchFilter () {
            this.resource.removeFilter({ module: this.filterModuleNamespace || this.$route.name, key: "search" })
        }
    }
}
</script>

<style lang="scss">
.uik-search {
    position: relative;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    .uik-search__container {
        position: relative;
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
    }
    .uik-search__icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
    }
    .uik-search__input {
        border: $borderDefault;
        border-radius: 4px;
        display: block;
        width: 100%;
        background: white;
        padding: 10px 15px 10px 35px;
        transition: 0.2s all;
        outline: none;
        font-size: 0.875rem;
        color: $textMain;
        &::placeholder {
            color: $textSecondary;
        }
        &:focus {
            border-color: $primary;
        }
    }
    .uik-search__input--clear {
        border: none;
        border-radius: 0;
        background: transparent;
        height: 34px;
        &::placeholder {
            color: $textBase;
        }
    }
    i.uikon {
        color: #b6b7bb;
        font-size: 14px;
        pointer-events: none;
    }
    button {
        padding: 1px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border: none;
        background: transparent;
        outline: none;
        i.uikon {
            position: relative;
            left: auto;
            margin: 0;
            transform: rotate(45deg);
            font-size: 12px;
            color: #b6b7bb;
            transition: color 0.15s;
        }
        &:hover i.uikon {
            color: $textSecondary;
        }
        &:active i.uikon {
            color: #b6b7bb;
        }
    }
}
</style>
